import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import ButtonType from "%/dynamic-components/render-engine/options/button-options/button-type";
import Icon from "%/dynamic-components/render-engine/options/icon-options/icon";
import IconPosition from "%/dynamic-components/render-engine/options/icon-options/icon-position";
import ButtonIconSize from "%/dynamic-components/render-engine/options/button-options/button-icon-size";
import IconGap from "%/dynamic-components/render-engine/options/button-options/icon-gap";
import TextAlignment from "%/dynamic-components/render-engine/options/button-options/text-alignment";
import ButtonAction from "%/dynamic-components/render-engine/options/button-options/button-action";
import TextOption from "%/dynamic-components/render-engine/options/text-options/text-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import Modal from "%/dynamic-components/render-engine/options/modal";
import LinkType from "%/dynamic-components/render-engine/options/link-type";
import HrefOption from "%/dynamic-components/render-engine/options/url-options/href-option";
import OpenInNewTab from "%/dynamic-components/render-engine/options/open-in-new-tab";
import ButtonSize from "%/dynamic-components/render-engine/options/button-options/button-size";

export default class ButtonOptions extends BaseOptionsBundle {

  optionTitle = "Button";
  static optionClassName = "i-dynamic-button";
  inspectorToolGroup = "button";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.BUTTON_TOOL_SET,
  };

  constructor(values = {}, hideFromInspector = {}, customTitle = null) {
    super(values, [
      new ButtonType(undefined, hideFromInspector["button-type"] ?? false),
      new ButtonSize(undefined, hideFromInspector["button-size"] ?? false),
      new TextOption(undefined, hideFromInspector["text-option"] ?? false),
      new Icon(undefined, hideFromInspector["icon"] ?? false),
      new IconPosition(undefined, hideFromInspector["icon-position"] ?? false),
      new ButtonIconSize(undefined, hideFromInspector["button-icon-size"] ?? false),
      new IconGap(undefined, hideFromInspector["icon-gap"] ?? false),
      new TextAlignment(undefined, hideFromInspector["text-alignment"] ?? false),
      new ButtonAction(undefined, true),
      new Modal(undefined, true),
      new LinkType(undefined, true),
      new HrefOption(undefined, true),
      new OpenInNewTab(undefined, true),
    ]);

    if (customTitle !== null) {
      this.optionTitle = customTitle;
    }
  }
}
